import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemsContainer", "itemTemplate", "itemRow", "destroyInput", "materialsPreview", "consumablesContainer", "consumableTemplate", "consumableRow", "consumableDestroyInput", "consumableUnit"]
  static values = { calculateUrl: String }

  connect() {
    this.calculateMaterials()
  }

  addItem(event) {
    event.preventDefault()

    const template = this.itemTemplateTarget.innerHTML
    const uniqueId = new Date().getTime()
    const newContent = template.replace(/NEW_RECORD/g, uniqueId)

    this.itemsContainerTarget.insertAdjacentHTML("beforeend", newContent)
  }

  removeItem(event) {
    event.preventDefault()

    const row = event.target.closest('[data-order-form-target="itemRow"]')

    if (!row) return

    const destroyInput = row.querySelector('[data-order-form-target="destroyInput"]')

    if (destroyInput && destroyInput.name.includes("[id]")) {
      // Existing record - mark for destruction
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      // New record - just remove from DOM
      row.remove()
    }

    this.calculateMaterials()
  }

  addConsumable(event) {
    event.preventDefault()

    if (!this.hasConsumableTemplateTarget) return

    const template = this.consumableTemplateTarget.innerHTML
    const uniqueId = new Date().getTime()
    const newContent = template.replace(/NEW_CONSUMABLE/g, uniqueId)

    this.consumablesContainerTarget.insertAdjacentHTML("beforeend", newContent)
  }

  removeConsumable(event) {
    event.preventDefault()

    const row = event.target.closest('[data-order-form-target="consumableRow"]')

    if (!row) return

    const destroyInput = row.querySelector('[data-order-form-target="consumableDestroyInput"]')

    if (destroyInput && destroyInput.name.includes("[id]")) {
      // Existing record - mark for destruction
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      // New record - just remove from DOM
      row.remove()
    }
  }

  updateConsumableUnit(event) {
    const select = event.target
    const row = select.closest('[data-order-form-target="consumableRow"]')
    if (!row) return

    const unitSpan = row.querySelector('[data-order-form-target="consumableUnit"]')
    if (!unitSpan) return

    const selectedOption = select.options[select.selectedIndex]
    const unit = selectedOption?.dataset?.unit || "-"
    unitSpan.textContent = unit
  }

  calculateMaterials() {
    if (!this.calculateUrlValue) return

    const form = this.element
    const formData = new FormData(form)

    // Rails edit 폼의 _method=patch를 제거하여 POST로 전송
    formData.delete("_method")

    fetch(this.calculateUrlValue, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error("Error calculating materials:", error)
    })
  }
}
